import React from 'react'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import { getDateFromIso } from '@App/helpers/get-date-iso-6801'

interface WorkItemSimpleHeadInfoProps {
    songCode?: string | null
    iswc?: string | null
    updateDate?: string | null
    rightsholderProprietaryId?: string | null
    totalKnownShares: number
}

const WorkItemSimpleHeadInfo = ({
    songCode,
    iswc,
    updateDate,
    rightsholderProprietaryId,
    totalKnownShares,
}: WorkItemSimpleHeadInfoProps) => (
    <>
        {songCode && (
            <p className="small-2">
                <span>MLC Song Code:&nbsp;</span>
                <span className="bold">{songCode}</span>
            </p>
        )}
        {iswc && (
            <p className="small-2">
                <span>ISWC:&nbsp;</span>
                <span className="bold">{iswc}</span>
            </p>
        )}
        {updateDate && (
            <p className="small-2">
                <span>Date:&nbsp;</span>
                <span className="bold">{getDateFromIso(updateDate)}</span>
            </p>
        )}
        {rightsholderProprietaryId && (
            <p className="small-2">
                <span>Member&apos;s Song ID:{'\u00a0'}</span>
                <span className="bold">{rightsholderProprietaryId}</span>
            </p>
        )}
        {totalKnownShares ? (
            <p className="small-2">
                <span>Total known shares:&nbsp;</span>
                <>
                    {totalKnownShares < 100 ? (
                        <span className="line">
                            <span className="bold">{totalKnownShares}%&nbsp;</span>
                            <CustomToolTip
                                type="?"
                                info="Part of these shares are unknown, so total is less than 100%"
                            />
                        </span>
                    ) : (
                        <span className="bold">{totalKnownShares}%</span>
                    )}
                </>
            </p>
        ) : null}
    </>
)

export default WorkItemSimpleHeadInfo
